"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intersection = exports.styleMapToAttribs = exports.isEmptyObject = exports.styleToString = exports.decodeBreakingEntities = exports.encodeBreakingEntities = exports.parseStyleCssText = void 0;

var camelize = function camelize(str) {
  return str.replace(/(?:^|[-])(\w)/g, function (a, c) {
    c = a.substring(0, 1) === '-' ? c.toUpperCase() : c;
    return c ? c : '';
  });
};

var parseStyleCssText = function parseStyleCssText(value) {
  var output = {};

  if (!value) {
    return output;
  }

  var style = value.split(';');

  var _iterator = _createForOfIteratorHelper(style),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;
      var rule = s.trim();

      if (rule) {
        var ruleParts = rule.split(':');
        var key = camelize(ruleParts[0].trim());
        output[key] = ruleParts[1].trim();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return output;
};

exports.parseStyleCssText = parseStyleCssText;

var encodeBreakingEntities = function encodeBreakingEntities(str) {
  var swapChar = function swapChar(charToSwap) {
    // that swaps characters to HTML entities
    switch (charToSwap) {
      case '&':
        return '&amp;';

      case '<':
        return '&lt;';

      case '>':
        return '&gt;';

      default:
        return charToSwap;
    }
  };

  str = str.replace(/[&<>]/g, function (match) {
    return swapChar(match);
  });
  return str;
};

exports.encodeBreakingEntities = encodeBreakingEntities;

var decodeBreakingEntities = function decodeBreakingEntities(str) {
  return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
};

exports.decodeBreakingEntities = decodeBreakingEntities;

var styleToString = function styleToString(style) {
  return Object.keys(style).reduce(function (acc, key) {
    return acc + key.split(/(?=[A-Z])/).join('-').toLowerCase() + ':' + style[key] + ';';
  }, '');
};

exports.styleToString = styleToString;

var isEmptyObject = function isEmptyObject(obj) {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
};

exports.isEmptyObject = isEmptyObject;

var styleMapToAttribs = function styleMapToAttribs(_ref) {
  var elementStyleMap = _ref.elementStyleMap,
      node = _ref.node;
  var attribs = {};
  var styleAttrs = {};
  Object.keys(elementStyleMap).forEach(function (slateKey) {
    var cssProperty = elementStyleMap[slateKey];
    var cssValue = node[slateKey];

    if (cssValue) {
      styleAttrs[cssProperty] = cssValue;
    }
  });

  if (!(0, exports.isEmptyObject)(styleAttrs)) {
    attribs = Object.assign(Object.assign({}, attribs), {
      style: (0, exports.styleToString)(styleAttrs)
    });
  }

  return (0, exports.isEmptyObject)(attribs) ? {} : attribs;
};

exports.styleMapToAttribs = styleMapToAttribs;

var intersection = function intersection(o1, o2) {
  return Object.keys(o1).concat(Object.keys(o2)).sort().reduce(function (r, a, i, aa) {
    if (i && aa[i - 1] === a) {
      r.push(a);
    }

    return r;
  }, []);
};

exports.intersection = intersection;